import React from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import style from '../styles/hamburger.module.styl';

class HamburgerLarge extends React.Component {
  constructor() {
    super();
    this.state = {
      showMenuMobile: false,
    };
  }

  setFullPageRef = ref => {
    this.fullPage = ref;
  };

  onClickMenuItemLarge = slide => () => {
    if (this.fullPage) {
      this.fullPage.scrollToSlide(slide);
    }
  };

  render() {
    return (
      <div className={style.hamburgerLarge}>
        <div className={style.hamburgerButton}>
          <div />
          <div />
          <div />
        </div>
        <div className={style.menuLarge}>
          <span onClick={this.onClickMenuItemLarge(1)}>HOME</span>
          <span onClick={this.onClickMenuItemLarge(2)}>WHAT WE OFFER</span>
          <span onClick={this.onClickMenuItemLarge(3)}>WHO WE ARE</span>
          <span onClick={this.onClickMenuItemLarge(4)}>LETS TALK</span>
        </div>
      </div>
    );
  }
}

class HamburgerMobile extends React.Component {
  constructor() {
    super();
    this.state = {
      showMenuMobile: false,
    };
  }

  handleClickOutside() {
    this.setState({
      showMenuMobile: false,
    });
  }

  onClick = () => {
    const { showMenuMobile } = this.state;
    this.setState({
      showMenuMobile: !showMenuMobile,
    });
  };

  render() {
    return (
      <div className={style.hamburgerMobile}>
        <div className={style.hamburgerButton} onClick={this.onClick}>
          <div />
          <div />
          <div />
        </div>
        {this.state.showMenuMobile && (
          <div className={style.menuMobile}>
            <a href="#homeScreen" onClick={this.onClick}>
              <span>HOME</span>
            </a>
            <a href="#offerScreen" onClick={this.onClick}>
              <span>WHAT WE OFFER</span>
            </a>
            <a href="#aboutUsScreen" onClick={this.onClick}>
              <span>WHO WE ARE</span>
            </a>
            <a href="#talkScreen" onClick={this.onClick}>
              <span>LETS TALK</span>
            </a>
          </div>
        )}
      </div>
    );
  }
}

const HamburgerMobileWithClickOutside = enhanceWithClickOutside(HamburgerMobile);

class Hamburger extends React.Component {
  hamburgerLargeRef = component => {
    this.hamburgerLarge = component;
  };

  setFullPageRef = ref => {
    this.hamburgerLarge.setFullPageRef(ref);
  };

  render() {
    return (
      <div className={style.hamburger}>
        <HamburgerLarge ref={this.hamburgerLargeRef} />
        <HamburgerMobileWithClickOutside />
      </div>
    );
  }
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/hamburger.js